import TaskService from '../services/task.service';

const DEBUG=true;

export const task = {
  namespaced: true,
  state: {
    tasks: [], // Fetch tasks from backend
    alertMessage: '',
  },
  // -----------------------------------
  getters: {
    getTasks: (state) => state.tasks,
    getAlertMessage: (state) => state.alert,
  },
  // -----------------------------------
  actions: {
    fetchTasks({ commit }) {
      return TaskService.fetchTasks()
      .then(
        db => {
          commit('storeFetchedTasks', db.tasks);
          return Promise.resolve(db.tasks);
        },
        error => {
          commit('setAlertMessage', error);
          return Promise.reject(error);
        }
      );
    },
    setTaskStatus({commit}, {taskID, status}){
      return TaskService.setTaskStatus({taskID, status})
      .then(
        response => {
            if(DEBUG) console.log('setTaskStatus', taskID, status, response);
            commit('setTask', {taskID, status} );
        },
        error => {
          commit('setAlertMessage', error.message);
          //return Promise.reject(error.message);
        }
      );       
    },
  },
  // -----------------------------------
  mutations: {
    setAlertMessage(state, alertMessage ){
      state.alertMessage = alertMessage;
    },
    storeFetchedTasks(state, taskArray ){
      state.tasks= taskArray;
    },
    setTask( state, { taskID, status } ){
      if(!status||status=="") return;
      const findIdx = state.tasks?.findIndex(row => row.id == taskID);
      state.tasks.splice(findIdx, 1, { ...state.tasks[findIdx], status: status});
    },
  }
};
